import types from 'constants/AuthConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
	userName: '',
	role: 2,
	isLogin: false,
	loggingIn: false,
	loginFail: false,
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.SET_AUTH_INFO:
			return state.merge({
				userName: action.userName,
				role: action.role,
				isLogin: true,
				loggingIn: false,
				loginFail: false,
			});

		case types.REMOVE_AUTH_INFO:
			return initialState;

		case types.ATTEMP_LOGIN:
			return state.set('loggingIn', true);

		case types.AUTH_FAIL:
			return state.merge({
				loggingIn: false,
				loginFail: true,
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Auth.js